import React , {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import './styles.scss'
import Button from '../../components/button';
import AboutItem from './about-item';
import Popup from '../../components/popup';


About.propTypes = {
    data : PropTypes.array,
};

function About(props) {

    const {data} = props;

    const [dataBlock] = useState(
        {
            subtitle : 'About us',
            title: 'WHAT IS ELEMENT DAO?'
        }
    )
    
    const [modalShow, setModalShow] = useState(false);


    useEffect(() => {
        if (modalShow) {
            setTimeout(() => {
                setModalShow(false) 
            }, 3000);
        }
    }, [modalShow])

    return (
        <section className="tf-section tf-about" id='about'>
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 col-md-12">
                        <div className="content-about mobie-40 mb-0" data-aos="fade-up" data-aos-duration="800">
                            <div className="tf-title st2">
                                <p className="h8 sub-title">{dataBlock.subtitle}</p>
                                <h4 className="title" style={{justifyContent: 'start'}}>{dataBlock.title}</h4>
                            </div>
                            <p className='mb-0'>
                            Element DAO is a community-driven decentralized organization on a mission to revolutionize Web3 DApp services, including NFT trading service within the thriving blockchain networks.<br /><br />
                            Our primary objectives include establishing a robust Web3 infrastructure, facilitating seamless integration of services for various blockchains and projects, and contributing to the overall growth of the decentralized ecosystem.
                            </p>
                            {/* <Button title="Details" path={'/eledao-details'}/> */}
                        </div>
                    </div>
                    <div className="col-xl-7 col-md-12" style={{display: 'flex', alignItems: 'center'}}>
                        <div className="wrap-about" data-aos="fade-up" data-aos-duration="800">
                            {
                                data.map(item => (
                                    <AboutItem key={item.id} item={item} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            
            <Popup modalShow={modalShow} setModalShow={() => {setModalShow(!modalShow)}} />

        </section>
    );
}

export default About;